export default __webpack_public_path__ + "cc4cda6a8c17b5752e74f1d7ce52f8b9.png";